import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Cert from '@/views/Cert.vue'
import qrcode from '@/views/statementqrcode.vue'
import Place from '@/views/Place.vue'
import Cert_check from '@/views/Cert_check.vue'

const routes = [
  {
    path: '/:deptId',
    name: 'home',
    component: Home
  },
  {
    path: '/qrcode/:id',
    name: 'qrcode',
    component: qrcode
  },
  {
    path: '/cert/:id/:print?',
    name: 'cert',
    component: Cert
  },
  {
    path: '/place/:placeId',
    name: 'Place',
    component: Place
  },
  {
    path: '/Cert_check/:id',
    name: 'Cert_check',
    component: Cert_check
  }
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
